import { render, staticRenderFns } from "./DataListUser.vue?vue&type=template&id=82f43b90&"
import script from "./DataListUser.vue?vue&type=script&lang=js&"
export * from "./DataListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports